<div class="button-row" #buttonRow>
  <button
    *ngFor="let opcaoPgmt of options; let i = index"
    [value]="opcaoPgmt.opcao"
    class="btn btn-full-orange"
    [id]="'opcao' + opcaoPgmt.opcao"
    [ngClass]="{focus: buttonToFocus(i)}"
    (click)="selectAll(i)"
  >
    D +{{opcaoPgmt.opcao}}
  </button>
</div>

<div class="table-content">
  <table class="table" aria-label="Tabela de propostas para aprovação em lote">
    <thead>
      <tr>
        <th scope="col">
          <span>PROPOSTA</span>
        </th>
        <th scope="col">
          <span>RETENÇÃO</span>
        </th>
        <th scope="col">
          <span>CARÊNCIA</span>
        </th>
        <th scope="col">
          <span>VALOR LIBERADO AO LOJISTA</span>
        </th>
        <th scope="col">
          <span>DATA DO PAGAMENTO</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let contrato of contratos; let i = index">
        <td>{{contrato.proposta}}</td>
        <td>{{contrato.opcoesPagamento[optionIndexes[i]].retencao}}%</td>
        <td>
          <select [(ngModel)]="optionIndexes[i]" (change)="changeD(i, $event.target.value)">
            <option
              *ngFor="let opcaoPgmt of options; let ii = index"
              [value]="ii"
            >
              D +{{opcaoPgmt.opcao}}
            </option>
          </select>
        </td>
        <td>{{contrato.opcoesPagamento[optionIndexes[i]].valor | currency:'BRL'}}</td>
        <td>{{contrato.opcoesPagamento[optionIndexes[i]].dataPagamento | date: 'dd/MM/yyyy'}}</td>
      </tr>
    </tbody>
  </table>
</div>
